import "core-js/modules/es.number.constructor.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b66bc1fa"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "modal-title"
};
var _hoisted_2 = {
  class: "d-flex fl-s-a"
};
var _hoisted_3 = {
  class: "numeric-wrapper"
};
var _hoisted_4 = {
  style: {
    "padding-top": "0px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_l_col = _resolveComponent("l-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    "close-on-press-escape": false,
    "show-close": false,
    width: "337px",
    top: "25vh",
    style: {
      "padding": "0px"
    },
    class: "payment-calculator"
  }, {
    title: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_row, {
        type: "flex",
        justify: "space-around",
        class: "input-wrapper"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 18,
            offset: 1
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("calculator.insert-amount")), 1), _createVNode(_component_el_row, {
                class: "input-screen",
                justify: "start"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_col, {
                    span: 6,
                    class: "currency"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.currentCurrency), 1)];
                    }),
                    _: 1
                  }), _createVNode(_component_l_col, {
                    span: 6
                  }, {
                    default: _withCtx(function () {
                      return [_withDirectives(_createElementVNode("input", {
                        class: "input-nums",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                          return _ctx.inputContent = $event;
                        }),
                        "data-cy": "payment-calc-amount"
                      }, null, 512), [[_vModelText, _ctx.inputContent]])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 2
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onKeydown: _withModifiers(_ctx.eraseFromInput, ["stop"]),
                class: "erase-button",
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.eraseFromInput();
                })
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_SvgIcon, {
                    iconContent: _ctx.iconContent,
                    iconAlt: _ctx.iconAlt,
                    iconStyle: _ctx.iconStyle
                  }, null, 8, ["iconContent", "iconAlt", "iconStyle"])];
                }),
                _: 1
              }, 8, ["onKeydown"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
        type: "flex",
        justify: "start",
        class: "buttons-wrapper"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[2] || (_cache[2] = function ($event) {
                  return _ctx.updateInput(String(1));
                }),
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("1")];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.updateInput(String(2));
                }),
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("2")];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[4] || (_cache[4] = function ($event) {
                  return _ctx.updateInput(String(3));
                }),
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("3")];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        type: "flex",
        justify: "start",
        class: "buttons-wrapper"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[5] || (_cache[5] = function ($event) {
                  return _ctx.updateInput(String(4));
                }),
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("4")];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[6] || (_cache[6] = function ($event) {
                  return _ctx.updateInput(String(5));
                }),
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("5")];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[7] || (_cache[7] = function ($event) {
                  return _ctx.updateInput(String(6));
                }),
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("6")];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        type: "flex",
        justify: "start",
        class: "buttons-wrapper"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[8] || (_cache[8] = function ($event) {
                  return _ctx.updateInput(String(7));
                }),
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("7")];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[9] || (_cache[9] = function ($event) {
                  return _ctx.updateInput(String(8));
                }),
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("8")];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _cache[10] || (_cache[10] = function ($event) {
                  return _ctx.updateInput(String(9));
                }),
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("9")];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _createVNode(_component_el_row, {
        type: "flex",
        justify: "start",
        class: "buttons-wrapper"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _ctx.updateZero,
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("0")];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                onClick: _ctx.updateInputDoubleZero,
                class: "calc-button"
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode("00")];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                class: "clear-btn calc-button",
                onClick: _ctx.clearInput
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("calculator.clear")), 1)];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), _createVNode(_component_el_button, {
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return _ctx.cancel();
        }),
        class: "cancel-btn"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
        class: "confirm-button",
        onClick: _cache[12] || (_cache[12] = function ($event) {
          return _ctx.$emit('confirmNumber', Number(_ctx.inputContent), _ctx.selectedCashCurrency);
        }),
        "data-cy": "confirm-price-btn"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("calculator.confirm-price")), 1)];
        }),
        _: 1
      })])];
    }),
    _: 1
  }, 8, ["modelValue"]);
}